// Render an Xtream-shaped rating field. The panel returns rating as a
// string ("0", "7.4", "0.0", "9.123456"), as a number, or null. Treat
// non-positive / non-finite values as "no rating" so cards don't display
// a meaningless "0".
export function formatRating(r: string | number | null | undefined): string | null {
  if (r === null || r === undefined || r === "") return null;
  const n = typeof r === "number" ? r : parseFloat(String(r));
  if (!Number.isFinite(n) || n <= 0) return null;
  return n.toFixed(2);
}

/**
 * Seconds as a clock: `12:04`, or `1:48:22` once past an hour.
 * Mirrors the private helper inside `Player.tsx`; extracted here because the
 * PiP controls render in a separate window and cannot reach into it.
 */
export function fmtClock(seconds: number): string {
  if (!isFinite(seconds) || seconds < 0) return "0:00";
  const t = Math.floor(seconds);
  const h = Math.floor(t / 3600);
  const m = Math.floor((t % 3600) / 60);
  const s = t % 60;
  return h > 0
    ? `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`
    : `${m}:${String(s).padStart(2, "0")}`;
}
